import inform7 from "refractor/inform7";
export default inform7;